import { COMPONENTS, DeepPartial, DEFAULT_EMPATHIZE_LAYOUT_CONFIG, EmpathizeConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_EMPATHIZE_CONFIG: DeepPartial<EmpathizeConfig> = {

  layout: {
    noQuery: [
      [
        DEFAULT_EMPATHIZE_LAYOUT_CONFIG.queryHistory,
        DEFAULT_EMPATHIZE_LAYOUT_CONFIG.popularSearches,
        DEFAULT_EMPATHIZE_LAYOUT_CONFIG.nextQueriesSuggestions
      ]
    ],
    query: [
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.suggestions]
    ],
    identifierSearch: [
      [DEFAULT_EMPATHIZE_LAYOUT_CONFIG.identifierSuggestions]
    ]
  }
};
export const DESKTOP_EMPATHIZE_CONFIG: DeepPartial<EmpathizeConfig> = {
  components: {
    panel: COMPONENTS.PANELS.BlockEmpathizePanel
  }
};
